import React, { useContext, useEffect, useRef } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

import './styles.scss';

// import required modules
import { EffectCoverflow, Navigation, Pagination } from 'swiper/modules';
import { AuthContext } from '../../../context'
import { CTAButton } from '../../../components'
import nextArrow from '../../../assets/images/svg/next_arrow.svg'
import prevarrow from '../../../assets/images/svg/prevarrow.svg'
import portfolio1 from '../../../assets/images/portfolio/new1.webp'
import portfolio2 from '../../../assets/images/portfolio/new2.webp'
import portfolio3 from '../../../assets/images/portfolio/new3.webp'
import portfolio4 from '../../../assets/images/portfolio/new4.webp'
import portfolio5 from '../../../assets/images/portfolio/new5.webp'
import portfolio6 from '../../../assets/images/portfolio/new6.webp'
import portfolio7 from '../../../assets/images/portfolio/new7.webp'
import portfolio8 from '../../../assets/images/portfolio/new8.webp'
import portfolio9 from '../../../assets/images/portfolio/new9.webp'
import portfolio10 from '../../../assets/images/portfolio/new10.webp'
import portfolio11 from '../../../assets/images/portfolio/new11.webp'
import portfolio12 from '../../../assets/images/portfolio/new12.webp'
import portfolio13 from '../../../assets/images/portfolio/new13.webp'
import portfolio14 from '../../../assets/images/portfolio/new14.webp'
import portfolio15 from '../../../assets/images/portfolio/new15.webp'
import portfolio16 from '../../../assets/images/portfolio/new16.webp'
import portfolio17 from '../../../assets/images/portfolio/new17.jpeg'
import portfolio18 from '../../../assets/images/portfolio/new18.jpeg'
import portfolio19 from '../../../assets/images/portfolio/new19.jpeg'
import portfolio20 from '../../../assets/images/portfolio/new20.jpeg'
import portfolio21 from '../../../assets/images/portfolio/new21.jpeg'
import portfolio22 from '../../../assets/images/portfolio/new22.jpeg'
import portfolio23 from '../../../assets/images/portfolio/new23.jpeg'
import portfolio25 from '../../../assets/images/portfolio/new25.jpeg'
import portfolio26 from '../../../assets/images/portfolio/new26.jpeg'
import portfolio27 from '../../../assets/images/portfolio/new27.jpeg'
import portfolio28 from '../../../assets/images/portfolio/new28.jpeg'
import portfolio29 from '../../../assets/images/portfolio/new29.webp'
import portfolio30 from '../../../assets/images/portfolio/new30.webp'
import portfolio31 from '../../../assets/images/portfolio/new31.webp'
import portfolio32 from '../../../assets/images/portfolio/new32.webp'
import portfolio33 from '../../../assets/images/portfolio/new33.webp'
import portfolio34 from '../../../assets/images/portfolio/new34.webp'
import portfolio35 from '../../../assets/images/portfolio/new35.webp'
import portfolio36 from '../../../assets/images/portfolio/new36.webp'


export default function PortfolioCarousel() {

  const { setCursor } = useContext(AuthContext)


  const swipper = useRef();
  const mouseHover = (type) => setCursor(type);
  const mouseOut = () => setCursor("");

  const slides = [
    {
      img: portfolio1,
    },
    {
      img: portfolio2,
    },
    {
      img: portfolio3,
    },
    {
      img: portfolio4,
    },
    {
      img: portfolio5,
    },
    {
      img: portfolio6,
    },
    {
      img: portfolio7,
    },
    {
      img: portfolio8,
    },
    {
      img: portfolio9,
    },
    {
      img: portfolio10,
    },
    {
      img: portfolio11,
    },
    {
      img: portfolio12,
    },
    {
      img: portfolio13,
    },
    {
      img: portfolio14,
    },
    {
      img: portfolio15,
    },
    {
      img: portfolio16,
    },
    {
      img: portfolio17,
    },
    {
      img: portfolio18,
    },
    {
      img: portfolio19,
    },
    {
      img: portfolio20,
    },
    {
      img: portfolio21,
    },
    {
      img: portfolio22,
    },
    {
      img: portfolio23,
    },
    {
      img: portfolio25,
    },
    {
      img: portfolio26,
    },
    {
      img: portfolio27,
    },
    {
      img: portfolio28,
    },
    {
      img: portfolio29,
    },
    {
      img: portfolio30,
    },
    {
      img: portfolio31,
    },
    {
      img: portfolio32,
    },
    {
      img: portfolio33,
    },
    {
      img: portfolio34,
    },
    {
      img: portfolio35,
    },
    {
      img: portfolio36,
    },
  ]

  const handleSlideTo = (index) => {
    if (swipper.current && swipper.current.swiper) {
      swipper.current.swiper.slideTo(index);
    }
  };

  useEffect(() => {
    handleSlideTo(1)
  }, [])
  return (
    <>
      <div className='slider__main__div' onMouseOver={() => mouseHover("hidden")}
        onMouseOut={mouseOut}>
        <Swiper
          effect={'coverflow'}
          ref={swipper}
          grabCursor={true}
          centeredSlides={true}
          slidesPerView={3}
          coverflowEffect={{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }}
          loop
          pagination={false}
          active={2}
          modules={[EffectCoverflow, Pagination, Navigation]}
          className="portfolio__swipper"
          navigation={{
            nextEl: '.custom-next-btn',
            prevEl: '.custom-prev-btn',
          }}
        >
          {slides?.map((v, i) => {
            return (
              <SwiperSlide key={i}>
                <div className='upper__div' />
                <img src={v.img} alt={`${i}`} />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      <div className='d-flex justify-content-center align-items-center gap-4 mb-4 mt-3'>
        <div>
          <button onMouseOut={mouseOut} onMouseOver={() => mouseHover("fill")} className='custom-prev-btn cutsom__btn'>
            <img src={prevarrow} alt='prevarr' />
          </button>
        </div>
        <div>
          <a href='/portfolio'>
            <CTAButton text={"View Portfolio"} />
          </a>
        </div>
        <div>
          <button onMouseOver={() => mouseHover("fill")} onMouseOut={mouseOut} className='custom-next-btn cutsom__btn'>
            <img src={nextArrow} alt='nextarr' />
          </button>
        </div>
      </div>
    </>
  );
}
